import React, { useEffect, useRef, useState } from 'react';
import { useApp } from '../../context/AppContext';
import { useCartCache } from '../../context/CartCacheContext';
import { readQs } from '../../../../../../../../shared/lib/querystring';
import { FullScreenLoader } from '../../components/FullScreenLoader';
import axios from 'axios';

export default function ConfirmationView() {
  const qs = readQs();
  const { config } = useApp();
  const { deleteCart } = useCartCache();

  const cartSessionId = (qs.go_success as string) || null;
  const src = cartSessionId ? config.confirmationUrl.replace(':cartId', cartSessionId) : null;
  const [loading, setLoading] = useState(true);

  const hostRef = useRef<HTMLDivElement>(null);
  const shadowRef = useRef<ShadowRoot | null>(null);

  async function refresh(attempt: number) {
    if (!src || !hostRef.current) return;

    if (!shadowRef.current) {
      shadowRef.current = hostRef.current.attachShadow({ mode: 'open' });
    }

    setLoading(true);

    await new Promise(resolve => setTimeout(resolve, 5000));

    try {
      const res = await axios.get(src);
      shadowRef.current.innerHTML = res.data;

      deleteCart(true);
      setLoading(false);
    } catch {
      if (attempt < 3) {
        refresh(attempt + 1);
      } else {
        shadowRef.current.innerHTML =
          'Unable to load cart confirmation data. Please notify the property of this error. ' +
          'You may have already paid for this booking.';
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    refresh(1).catch(console.error);
  }, [src]);

  return (
    <div>
      {loading && <FullScreenLoader />}
      <div className="bg-border" ref={hostRef} />
    </div>
  );
}
